// extracted by mini-css-extract-plugin
module.exports = {"a-list-item__title":"InfoColumn_a-list-item__title__z7hwu","a-list-item__desc":"InfoColumn_a-list-item__desc__2AmcG"};